import { CompositeAccessRule } from "./CompositeAccessRule.js";
function defineAccessControlledResource(resource) {
  return resource;
}
function combineResources(resources, operator) {
  return {
    name: resources.map((resource) => resource.name).join("_"),
    rules: new CompositeAccessRule(
      resources.map((resource) => resource.rules),
      operator
    )
  };
}
export {
  combineResources,
  defineAccessControlledResource
};
//# sourceMappingURL=utils.js.map
